import { Modal } from 'antd'
import { CSSProperties, PropsWithChildren } from 'react'
import { CloseOutlined } from '@ant-design/icons'
import styles from './Modal.module.less'

export type BaseModalProps = {
    width?: string
    className?: string
    open: boolean
    modalFooter?: React.ReactElement
    modalHeader?: React.ReactElement
    closable?: boolean
    onCancel?: () => void
    destroyOnClose?: boolean
    afterClose?: () => void
    disableAnimation?: boolean
    closeIconStyles?: CSSProperties
}

const BaseModal: React.FC<PropsWithChildren<BaseModalProps>> = props => {
    return (
        <div data-testid="modal-wrapper">
            <Modal
                width={props.width ?? '632px'}
                className={`modal-comp  ${props.className}`}
                title={props.modalHeader}
                closable={props.closable}
                open={props.open}
                footer={props.modalFooter ?? null}
                onCancel={props.onCancel}
                destroyOnClose={props.destroyOnClose}
                afterClose={props.afterClose}
                transitionName={props.disableAnimation ? '' : undefined}
                closeIcon={
                    <CloseOutlined
                        className={styles.closeIcon}
                        style={{ ...(props.closeIconStyles ?? {}) }}
                    />
                }
            >
                {props.children}
            </Modal>
        </div>
    )
}

export default BaseModal
